// extracted by mini-css-extract-plugin
module.exports = {"PageLayout":"PageLayout_PageLayout__K8axR","mainContent":"PageLayout_mainContent__kqDUL"};